import { Component, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AlertModalComponent } from '../../alert-modal//alert-modal.component';

@Component({
  selector: 'app-source-document-dialog',
  template: `
    <h1 mat-dialog-title class="dark-title">{{ data.metadata.title }}</h1>
    <div mat-dialog-content class="dark-content">
      <mat-expansion-panel class="dark-expansion-panel">
        <mat-expansion-panel-header>
          <mat-panel-title class="dark-title">Metadata</mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngFor="let key of metadataKeys">
          <strong>{{ key }}:</strong> {{ data.metadata[key] }}
        </div>
      </mat-expansion-panel>
      <div *ngIf="summaryContent" class="parsed-content">
        <h2>Summary</h2>
        <pre>{{ summaryContent }}</pre>
      </div>
      <div *ngIf="mainContent" class="parsed-content">
        <h2>Content</h2>
        <pre>{{ mainContent }}</pre>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Close</button>
    </div>
  `,
  styles: [
    `
      :host {
        color: #ffffff;
        background-color: #424242;
        background: var(--mat-sys-primary-container);
      }
      h1,
      mat-panel-title,
      p,
      strong {
        color: #ffffff;
      }
      .dark-content {
        background-color: #424242;
        color: #ffffff;
      }
      mat-expansion-panel {
        background-color: #616161;
      }
      .parsed-content {
        margin-top: 15px;
        background-color: #333;
        color: #ffffff;
        padding: 10px;
        border-radius: 4px;
      }
      .parsed-content h2 {
        margin-top: 0;
      }
      pre {
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    `
  ]
})
export class SourceDocumentDialogComponent implements AfterViewInit {
  metadataKeys: string[];
  summaryContent: string | null = null;
  mainContent: string | null = null;

  constructor(
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {
    this.metadataKeys = Object.keys(this.data.metadata);

    // Parse the content
    this.parseContent(data.content);
  }

  // TODO check use of empty hook.
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  ngAfterViewInit() {}

  parseContent(content: string): void {
    const summaryMatch = content.match(/<summary>([\s\S]*?)<\/summary>/);
    const contentMatch = content.match(/<content>([\s\S]*?)<\/content>/);

    this.summaryContent = summaryMatch ? summaryMatch[1].trim() : null;
    this.mainContent = contentMatch ? contentMatch[1].trim() : null;

    // Check if there is no content to display
    if (!this.summaryContent && !this.mainContent) {
      this.dialog.open(AlertModalComponent, {
        data: {
          title: 'No Content Available',
          message: 'There is no content available for this source document.'
        }
      });
    }
  }
}
